import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Toasted from 'vue-toasted';
import VTooltip from 'v-tooltip';
import VueApexCharts from 'vue-apexcharts';
import Buefy from 'buefy';
import VueSVGIcon from 'vue-svgicon';
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';
import VueAxios from 'vue-axios';
import * as Sentry from '@sentry/browser';
import VueLogger from 'vuejs-logger';
import App from './App.vue';
import router from './router';
import store from './store/store';
import authClient from './auth/auth0/client';
import VueAuth0 from './auth/auth0/plugin';
import VueApolloClients from './store/graphql/plugin';
import typeDefs from './defs';
import './filters';
import './icons'; // Importing all of the icons here so they are registered with VueSVGIcon

Vue.config.productionTip = false;

// Do not report errors to sentry in development mode
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({ dsn: process.env.VUE_APP_SENTRY });
}

// Axios is used to grab the /config/login.json for auth
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.use(VueSVGIcon);
Vue.use(Toasted);
Vue.use(VTooltip);
Vue.use(VueApexCharts);
Vue.use(Buefy, {
  defaultIconPack: 'fas',
});
Vue.use(VueAuth0, { authClient });
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: process.env.VUE_APP_LOG_LEVEL,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
});

// This loads and registers Vue.$apollo.primary and Vue.$apollo.admin
Vue.use(VueApolloClients, {});

sync(store, router);

// Load the defintion files and save them to Vue.$typeDefs
Object.defineProperties(Vue.prototype, {
  $typeDefs: {
    get() {
      return typeDefs.getTypeDefinitions();
    },
  },
});

// Define an eventBus that will pass on window events like keypresses
const eventBus = new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    const vm = this;
    window.addEventListener('keyup', (event) => {
      // If down arrow was pressed...
      if (event.keyCode === 40) {
        vm.$bus.$emit('down-arrow-pressed');
      } else if (event.keyCode === 38) {
        vm.$bus.$emit('up-arrow-pressed');
      }
    });
  },
});

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return eventBus;
    },
  },
});

// Save the main Vue to window.app, used for the tester to get access to the main Vue instance
window.app = eventBus;

// Finally mount the app to #app
eventBus.$mount('#app');
